// Schema della persona del chatbot (per ogni flow).
// Single source of truth tra backend (validation) e admin frontend (form).
import { z } from 'zod';
export const PersonaToneEnum = z.enum(['caldo', 'professionale', 'rassicurante', 'neutro']);
export const PersonaFormalityEnum = z.enum(['tu', 'lei', 'auto']);
export const PersonaEmojiEnum = z.enum(['mai', 'raro', 'moderato']);
export const PersonaSchema = z.object({
    // Nome del bot, es. "Audiq" o "Sara"
    name: z.string().min(1).max(40).default('Audiq'),
    // Ruolo, es. "operatore di accoglienza medica"
    role: z.string().max(120).default('operatore di accoglienza'),
    tone: PersonaToneEnum.default('caldo'),
    formality: PersonaFormalityEnum.default('auto'),
    use_emoji: PersonaEmojiEnum.default('mai'),
    // Override del messaggio di apertura/chiusura. Se vuoto, l'LLM lo genera.
    opening_message: z.string().max(500).optional().default(''),
    closing_message: z.string().max(500).optional().default(''),
});
export const BoundariesSchema = z.array(z.string().min(3).max(200)).max(20);
//# sourceMappingURL=persona.js.map